import {InputTitleNormal} from '../../common/TitleStyle'
import styled from '@emotion/styled'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Tooltip from '@mui/material/Tooltip'
import PropTypes from 'prop-types'
import {Checkbox, ClickAwayListener, IconButton} from '@mui/material'

const DataAggregationSubTitle = styled(InputTitleNormal)(({theme}) => ({
  marginBottom: '24px',
  marginLeft: '8px',
  color: theme.palette.grey[600]
}))

const StyledErrorOutline = styled(ErrorOutlineIcon)(({theme}) => ({
  color: theme.palette.hpAccentOrange,
  fontSize: theme.typography.h5.fontSize
}))

const StyledDiv = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '8px'
}))

const ToBeStyledTooltip = ({className, onClickAway, ...props}) => (
  <ClickAwayListener onClickAway={onClickAway}>
    <Tooltip {...props} classes={{tooltip: className}} placement='right-start' />
  </ClickAwayListener>
)

const StyledTooltip = styled(ToBeStyledTooltip)(({theme}) => ({
  borderRadius: '4px',
  fontSize: theme.typography.subtitle1.fontSize,
  backgroundColor: theme.palette.hpBaseDarker,
  fontFamily: theme.typography.fontFamily,
  maxWidth: '400px',
  lineHeight: theme.typography.h2.lineHeight
}))

const StyledIconButton = styled(IconButton)(({theme}) => ({
  color: theme.palette.primary.main,
  padding: '0px'
}))

const StyledCheckbox = styled(Checkbox)(({theme}) => ({
  color: theme.palette.hpPrimary
}))

ToBeStyledTooltip.propTypes = {
  className: PropTypes.string,
  onClickAway: PropTypes.func
}

export {DataAggregationSubTitle, StyledErrorOutline, StyledDiv, StyledTooltip, StyledIconButton, StyledCheckbox}
